<template>
  <div>
    <div>
      <el-form v-if="form" :model="form" ref="form" label-width="100px" :hide-required-asterisk="false">
        <div>
          <el-form-item label="考试名称" prop="batchId" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-select v-model="form.batchId" placeholder="选择考试" :disabled="row && !!row.batchId" filterable style="width: 410px;">
              <el-option v-for="(item,index) in batchList" :key="index" :label="item.batchName" :value="item.batchId" :class="item.disabled?'none':''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算时间" prop="addTime" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-date-picker v-model="form.addTime" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm" :default-time="['00:00:00','23:59:59']" style="width:410px;margin-right:10px;margin-bottom: 10px;"></el-date-picker>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="text-right">
      <el-button size="medium" @click="$emit('close', form)">取消</el-button>
      <el-button size="medium" type="primary" @click="save()" style="margin-right: 0px;">确定</el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'review-edit',
  components: {},
  props: ['row'],
  data () {
    return {
      form: { batchId: '', agentId: '' },
      batchList: [],
      // pickerOptions: {
      //   disabledDate (time) {
      //     return time >= Date.now()
      //   }
      // }
    }
  },
  async created () {
    this.batchList = await this.$HTTP.ApiBatch.getList({ batchStatus: [2, 3] })
    if (this.Tool.isNull(this.batchList)) {
      throw new Error('没有考试数据')
    }
    if (!this.form.batchId) {
      this.form.batchId = this.batchList[0].batchId
    }
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async save () {
      try {
        let isOK = await this.Tool.checkForm(this.$refs['form'])
        if (isOK) {
          if (this.form.addTime) {
            this.$set(this.form, 'startTime', this.form.addTime[0])
            this.$set(this.form, 'endTime', this.form.addTime[1])
          }
          // let end = new Date(this.form.endTime)
          // end.setDate(end.getDate() + 1)
          //
          // this.form.endTime = await this.getTime(end)
          await this.$HTTP.ApiSettle.addSettle(this.form)
          this.$message({ type: 'success', message: '操作成功' })
          this.$emit('close', this.form)
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    getTime (time) {
      let date = new Date(time)
      let y = date.getFullYear()
      let m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
      let d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
      return y + '-' + m + '-' + d
    },
  }
}
</script>
